export default __webpack_public_path__ + "static/media/camera_permission_en.0c80897a.png";